import React from 'react';

import useUser from 'hooks/useUser';

import ProfilePage from 'pages/profile';
import AdminBurnCenters from './admin';

const BurnCentersPage = () => {
  const { isAdmin, isBdataAmin } = useUser();
  return (isAdmin || isBdataAmin) ? <AdminBurnCenters /> : <ProfilePage />;
};

export default BurnCentersPage;
